import type { Clock } from 'lucide-react'

/**
 * Ligne de métadonnées d'une carte : durée, temps passé, seuil.
 *
 * Chaque élément disparaît quand sa donnée manque, et la ligne entière avec eux.
 * C'est le cas courant — un paquet SCORM qui ne déclare ni durée ni seuil est
 * banal —, et une ligne de tirets vaudrait moins que rien.
 */
function MetaLine({ items }: { items: ({ icon: typeof Clock, label: string } | null)[] }) {
  const shown = items.filter(item => item != null)
  if (shown.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
      {shown.map(({ icon: Icon, label }) => (
        <span key={label} className="inline-flex items-center gap-1.5">
          <Icon className="size-3.5 shrink-0" />
          {label}
        </span>
      ))}
    </div>
  )
}

export default MetaLine
